package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*
import org.jbox2d.common.*

class PhysicCorrectionsSystem : IteratingSystem(family { all(PlayerComponent, PhysicComponent) }) {
    override fun onTickEntity(entity: Entity) {
        val physComp = entity[PhysicComponent]
        val playerComp = entity[PlayerComponent]

        if (playerComp.playerMetadata.playerPhysicState.isGrounded) {
            physComp.body.linearVelocityY = 0f
        }

//        if (MathUtils.abs(physComp.body.linearVelocityY) < 0.001f) {
//            physComp.body.linearVelocityY = 0f
//        }

        if (MathUtils.abs(physComp.body.linearVelocityX) < 0.001f) {
            physComp.body.linearVelocityX = 0f
        }

        if (!playerComp.isDashActive && physComp.body.linearVelocityX > 3f) {
            physComp.body.linearVelocityX = 3f
        }
        if (!playerComp.isDashActive && physComp.body.linearVelocityX < -3f) {
            physComp.body.linearVelocityX = -3f
        }

        if (physComp.body.linearVelocityY < -5f) {
            physComp.body.linearVelocityY = -5f
        }
    }
}
